import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class IncomeByItemReportService {

  constructor(private http: HttpClient) { }

  query({ siteId, centerId, date, excludeSecurityDeposits = false }): Observable<Record<string, any>[]> {
    return this.http.get<Record<string, any>[]>(`api/sites/${siteId}/api/v1/centers/${centerId}/income-by-item-reports?snapshotDate=${date}&excludeSecurityDeposits=${excludeSecurityDeposits}`)
      .pipe(map((i: Record<string, any>) => Array.isArray(i) ? i : []));
  }
}
